import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "NotificationStatusMessage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "NotificationStatus",
    class: _normalizeClass([
			'CampaignEditorRow',
			_ctx.className
		])
  }, [
    _createElementVNode("i", {
      class: _normalizeClass([
				'NotificationStatusIcon',
				_ctx.icon
			])
    }, null, 2 /* CLASS */),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.message), 1 /* TEXT */)
  ], 2 /* CLASS */))
}